import {StyleParamType, wixColorParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type BackgroundAndBordersStylesParams = {
  backgroundAndBordersAppBackgroundColor: StyleParamType.Color
  backgroundAndBordersCardBackgroundColor: StyleParamType.Color
  backgroundAndBordersCardBorderWidth: StyleParamType.Number
  backgroundAndBordersCardBorderColor: StyleParamType.Color
  backgroundAndBordersCardCornerRadiusTopLeft: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusTopRight: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusBottomLeft: StyleParamType.Number
  backgroundAndBordersCardCornerRadiusBottomRight: StyleParamType.Number
}

export const backgroundAndBordersStylesParams =
  createStylesParams<BackgroundAndBordersStylesParams>({
    backgroundAndBordersAppBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-1', 1),
      metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
    },
    backgroundAndBordersCardBackgroundColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-8', 0.1),
      metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 0.1),
    },
    backgroundAndBordersCardBorderWidth: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
      metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 0}),
    },
    backgroundAndBordersCardBorderColor: {
      type: StyleParamType.Color,
      getDefaultValue: wixColorParam('color-37', 0.12),
      metadata: colorMetadata(StyleType.borderColor, 'color-37', 0.12),
    },
    backgroundAndBordersCardCornerRadiusTopLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
      metadata: numberMetadata(StyleType.borderTopLeftRadius, {defaultValue: 0}),
    },
    backgroundAndBordersCardCornerRadiusTopRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
      metadata: numberMetadata(StyleType.borderTopRightRadius, {defaultValue: 0}),
    },
    backgroundAndBordersCardCornerRadiusBottomLeft: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
      metadata: numberMetadata(StyleType.borderBottomLeftRadius, {defaultValue: 0}),
    },
    backgroundAndBordersCardCornerRadiusBottomRight: {
      type: StyleParamType.Number,
      getDefaultValue: () => 0,
      metadata: numberMetadata(StyleType.borderBottomRightRadius, {defaultValue: 0}),
    },
  })
